var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup_body"},[_c('div',{staticClass:"popup_body_div"},[_c('div',{staticClass:"popup_icon_one",on:{"click":_vm.alterPassClick}},[_vm._m(0),_c('p',[_vm._v("修改密码")])])]),_c('div',[_c('change-password-popup',{ref:"password",on:{"closePopup":_vm.closePopup}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup_img"},[_c('i',{staticClass:"iconfont icon-jiekou"})])
}]

export { render, staticRenderFns }